import React, { useEffect, useState } from "react";
import { MDBIcon } from "mdbreact";
import {
  Alert, Card, CardBody, FormGroup, Form, Input, InputGroupAddon,
  InputGroupText, InputGroup, Row, Col, Container, Button, UncontrolledCollapse
} from "reactstrap";
import { Dots } from "react-preloaders";
import axios from "utils/api";
import 'styles/_login.scss';

const Login = () => {
  //const [settings, setSettings] = useState([]);
  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({
    values: {
      accountId: '',
      username: '',
      password: ''
    },
    showPassword: false,
    errorColor: 'danger',
    errorMessage: 'There was a problem signing in to your account. Please try again later.'
  });

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      localStorage.removeItem('token_expired');
      // remove values from validation
      // localStorage.removeItem('enforcePasswordHistory');
      localStorage.removeItem('validationToken');

      // alert("TestAuthLogin");
      // axios.get(`settings/getbyid?id=1`)
      //   .then(response => {
      //     if (response) {
      //       setSettings(response.data.settings);
      //     }
      //   });
    }
  }, []);

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  const handleShowPassword = () => {
    setFormState({ ...formState, showPassword: !formState.showPassword });
  };

  const handleChange = (event, value, param) => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [param]: value
      },
      touched: {
        ...formState.touched,
        [param]: true
      }
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (formState.values.username !== '' && formState.values.password !== '' && formState.values.accountId !== '') {
      setLoading(true);

      axios.post('auth/login', {
        accountId: formState.values.accountId,
        username: formState.values.username,
        password: formState.values.password
      }).then((response) => {
        if (response.status === 200) {
          if (response.data.loginStatus !== undefined) {
            if (response.data.loginStatus === 1) {
              localStorage.setItem('auth', JSON.stringify(response.data));
              localStorage.setItem('token_expired', 'false');

              var auditlog = {
                moduleName: 'Login Page',
                merchantGroupId: response.data?.merchantGroupId,
                accountId: response.data?.merchantGroupCode,
                username: response.data?.username,
                actionsTaken: 'System login'
              };

              axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });

              window.location.replace("/admin/index");
            }
          } else {
            let errorMessage = 'There was a problem signing in to your account. Please try again later.';

            if (response.data === 32001)
              errorMessage = 'Invalid username or password combination. Please try again.';
            else if (response.data === 36098)
              errorMessage = 'Your account has expired. Please contact your system administrator.';
            else if (response.data === 40195)
              errorMessage = 'Your account has been locked. Please contact your system administrator.';
            else if (response.data === 68868)
              errorMessage = 'Your account is inactive. Please contact your system administrator.';
            else if (response.data === 27911)
              errorMessage = 'Invalid Details. Please enter correct credentials.';
            else
              errorMessage = 'You\'ve reached the maximum login limit. Your account has been locked.';

            setFormState({ ...formState, errorMessage: errorMessage });

            setOpenAlert(true);
          }
        }

        setLoading(false);
      }).catch(() => {
        setFormState({
          ...formState,
          errorMessage: `You're not allowed to access the portal. Please contact your system administrator.`
        });

        setOpenAlert(true);

        setLoading(false);
      });
    } else {
      setFormState(formState => ({
        ...formState,
        errorMessage: 'Please fill out the required fields to proceed.'
      }));

      setOpenAlert(true);

      setLoading(false);
    }
  };

  document.body.style.overflow = '';
  document.body.style.position = 'relative';

  return (
    <>
      <Col lg="5" md="7" className="login-container">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <Container>
              <Row>
                <img className="company-logo" src="/logo/rcbc-inst-qrph-transparent.png" alt="Rizal Commercial Banking Corporation" />
              </Row>
            </Container>
            <div className="text-center mt-3 mb-4">
              Log in to your account.
            </div>
            <Form role="form">
              {
                loading && <Dots background="rgba(192,192,192,0.3)" customLoading={loading} color="#000099" />
              }
              {
                openAlert &&
                (
                  <Alert className="login-error" color="danger" isOpen={openAlert} toggle={handleAlertClose} fade={true}>
                    <i className="fa fa-exclamation-triangle icon-margin-right"></i>
                    {formState.errorMessage}
                  </Alert>
                )
              }
              <FormGroup className="mb-1">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-briefcase-24" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Account ID"
                    type="input"
                    name="accountId"
                    value={formState.values.accountId || ''}
                    onChange={event => handleChange(event, event.target.value, event.target.name)}
                    onKeyPress={
                      event => {
                        if (event.key === 'Enter')
                          handleSubmit(event)
                      }
                    }
                    required
                    data-error="Account ID is required"
                    autoComplete="off" />
                </InputGroup>
              </FormGroup>
              <FormGroup className="mb-1">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-badge" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Username"
                    type="input"
                    name="username"
                    value={formState.values.username || ''}
                    onChange={event => handleChange(event, event.target.value, event.target.name)}
                    onKeyPress={event => { if (event.key === 'Enter') { handleSubmit(event) } }}
                    required
                    data-error="User Name is required"
                    autoComplete="off" />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Password"
                    type={formState.showPassword ? "text" : "password"}
                    name="password"
                    value={formState.values.password || ''}
                    onChange={event => handleChange(event, event.target.value, event.target.name)}
                    onKeyPress={(e) => { if (e.key === 'Enter') handleSubmit(e); }}
                    onPaste={(e) => { e.preventDefault(); return false; }}
                    onCopy={(e) => { e.preventDefault(); return false; }}
                    required
                    data-error="Password is required"
                    autoComplete="off"
                  />
                  <InputGroupText onClick={handleShowPassword}>
                    <MDBIcon icon={formState.showPassword ? "eye-slash" : "eye"} />
                  </InputGroupText>
                </InputGroup>
              </FormGroup>
              <div className="container">
                <div className="row">
                  <div className="text-Left col-sm-8">
                  </div>
                  <div className="text-right col-sm-4 " color="primary" id="toggler" style={{ marginBottom: '1rem', 'font-size': '14px' }}>
                    Forgot Password?
                  </div>
                </div>

                <UncontrolledCollapse toggler="#toggler" className="text-left">
                  <Card>
                    <CardBody>
                      <p style={{ 'font-size': '13px' }}>To request for reset password for Admin Merchant Portal User, please contact 8688-1888 loc 2343 or send an email to p2merchants@rcbcbankard.com and provide your “Merchant Name”, “Merchant Group MID” and “Username”.</p>

                      <p style={{ 'font-size': '13px' }}>To request for reset password for Sub-Merchant Portal User, please contact your administrator and provide your "Username".</p>
                    </CardBody>
                  </Card>
                </UncontrolledCollapse>
              </div>
              <div className="text-center">
                <Button
                  color="info"
                  href="#pablo"
                  className="login-button"
                  disabled={formState.values.username !== '' && formState.values.password !== '' && formState.values.accountId !== '' ? false : true}
                  onClick={(event) => handleSubmit(event)}>
                  Login
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
}

export default Login;
